import React, { useEffect, useRef } from "react";
import { MessagesList } from "./lib/stellar_msg";
import useContextUpdateFromSocket from "./helpers/useContextUpdateFromSocket";
import {
  AppContext,
  RoundUserContext,
  ValueContext,
} from "./context/createContext";
import Game from "./components/Game";
import { useSettings } from "./settings/useSettings";
import { createSocket } from "./socket/createSocket";
// import FPSLogger from "./components/fpslogger";
import { isSafari } from "react-device-detect";

function App() {
  const WS_URL = "{{SERVER_WS_URL}}";
  const name = "astro";
  const loginName = "orbital.stellar";

  const socket = useRef<any>(null);

  const {
    receiveMessage,
    // setStatus,
    context,
    users,
    newRoundUser,
    stellarSocketMessages,
    handleErrorText,
    roundValue,
  } = useContextUpdateFromSocket(socket, MessagesList, loginName);

  useEffect(() => {
    if (isSafari) {
      document.documentElement.className = "no-refresh";
    }
  }, []);

  // useEffect(() => {
  //   if (!socket.current)
  //     createSocket(socket, receiveMessage, setStatus, WS_URL, name, environment)
  // }, [socket, receiveMessage, setStatus])

  useEffect(() => {
    if (!socket.current)
      socket.current = createSocket(
        WS_URL,
        receiveMessage,
        name,
        handleErrorText
      );
  }, [socket, receiveMessage]);

  const { isError, globalSocketMessages, jackpotIsActive } = context;
  const settingsFromSocket = useSettings(globalSocketMessages);

  useEffect(() => {
    const interval = setInterval(() => {
      !isError && jackpotIsActive && stellarSocketMessages.getJackpot();
    }, 5000);
    isError && clearInterval(interval);

    return () => clearInterval(interval);
  }, [isError, jackpotIsActive]);

  useEffect(() => {
    console.log(
      "%cV.2.0.4 DG",
      "color: pink; background: black; padding: 5px; border-radius: 8px;"
    );
  }, []);

  return (
    <RoundUserContext.Provider value={newRoundUser}>
      <AppContext.Provider value={context}>
        <ValueContext.Provider value={roundValue}>
          <Game />
        </ValueContext.Provider>
      </AppContext.Provider>
    </RoundUserContext.Provider>
  );
}

export default App;
